const ButtonDelete = ({ onClick })=>{
    return (
        <button onClick={onClick} className="text-red-500 hover:text-green-700">
            <span className="material-icons-outlined">delete</span>
        </button>
    );
};

export default ButtonDelete;